import React from 'react';

import { Group } from '../../atoms/graphs';

export interface Props {
  data: any[];
  label?: any;
  scale: any;
  value: any;
}

class XAxis extends React.Component<Props, any> {
  static defaultProps: Partial<Props> = {
    label: String,
  };
  private textViewBoxWidth = 120;
  private textWidth = this.textViewBoxWidth / 2;

  public render() {
    const { data, label, scale, value } = this.props;

    return (
      <Group className="axis">
        {data.map((d, i) => {
          const x = scale(value(d));
          const labelString = label(d);

          return (
            <svg
              width={this.textWidth}
              height="2em"
              x={x - this.textWidth / 2}
              key={`tick-${i}`}
              viewBox={`0 0 ${this.textViewBoxWidth} 1`}
            >
              <text
                className="tick"
                x={this.textViewBoxWidth / 2}
                textAnchor="middle"
              >
                {labelString}
              </text>
            </svg>
          );
        })}
      </Group>
    );
  }
}

export default XAxis;
